import { memo } from 'react'
import { navigate } from '../../../app/router'
import { ArrowUpRight } from 'lucide-react'
import './embeds.css'

export const Embeds = memo(function Embeds() {
  return <footer className="v5-embeds" data-zone="embeds" data-qa="embed-entry"><span>Weather Fusion<span className="v5-footer-divider">·</span>Forecasts from multiple weather models.</span><nav aria-label="Widgets and developers"><button data-nav-key="widget-studio" onClick={() => navigate('/studio')}>Widget Studio <ArrowUpRight size={16} aria-hidden="true" /></button><a href="/developers">Developers & API <ArrowUpRight size={16} aria-hidden="true" /></a></nav></footer>
})
